import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./../styles/footer.css";

const Footer = () => {
  const location = useLocation();

  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <p className="footer-text">© 2025 V-Assistant. All rights reserved.</p>
        <ul className="footer-links">
          <li>
            {location.pathname === "/" ? (
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll("features");
                }}
              >
                Features
              </a>
            ) : (
              <Link to="/" onClick={() => setTimeout(() => handleScroll("features"), 100)}>
                Features
              </Link>
            )}
          </li>
          <li>
            {location.pathname === "/" ? (
              <a
                href="#pricing"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll("pricing");
                }}
              >
                Pricing
              </a>
            ) : (
              <Link to="/" onClick={() => setTimeout(() => handleScroll("pricing"), 100)}>
                Pricing
              </Link>
            )}
          </li>
          <li>
            {location.pathname === "/" ? (
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll("contact");
                }}
              >
                Contact
              </a>
            ) : (
              <Link to="/" onClick={() => setTimeout(() => handleScroll("contact"), 100)}>
                Contact
              </Link>
            )}
          </li>
          <li>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;